<style scoped>
	.main-window-modal {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .18);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	/*window*/
	.main-window {
		width: 600px;
		height: 600px;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		box-shadow: -1px -1px 20px 0 #fff;
		position: absolute;
	}

	/*关闭弹窗*/
	.close-btn:hover {
		color: red;
	}

	.close-btn {
		position: absolute;
		right: 0;
		top: 2px;
		font-size: 40px;
		cursor: pointer;
		line-height: 20px;
	}

	/*111111*/
	.top-title {
		height: 75px;
		background: rgba(11, 98, 166, 1);
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		cursor: move;
	}

	.top-title>.title-1,
	.top-title>.title-2 {
		color: #ffffff !important;
		padding: 3px 0 !important;
	}

	.top-title>.title-1 {
		font-size: 20px;
	}

	/*333333*/
	.input-util {
		height: 60px;
		background: rgba(244, 244, 244, 1);
		display: flex;
		align-items: center;
	}

	.input-box {
		height: 80%;
		flex: 1;
		text-align: left;
		text-indent: 20px;
		margin: 0 5px;
		padding: 0 5px;
		max-width: 520px;
		max-height: 100%;
		overflow-y: auto;
		border: none;
		outline: none;
		font-size: 14px;
		resize: none;
		background: rgba(0, 0, 0, 0);
	}

	.input-box:empty::before {
		content: attr(placeholder);
	}

	.send-btn {
		background: url("../../../assets/images/send_icon.png") no-repeat;
		height: 20px;
		line-height: 20px;
		color: #0B62A6;
		text-indent: 25px;
		cursor: pointer;
	}

	/*222222*/
	.msg-content {
		background: #ffffff;
		flex: 1;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
	}
</style>
<!--
  消息窗口组件
-->
<template>
	<div class="main-window-modal" @mousemove="mouseMove">
		<div class="main-window" :style="(dragClient.x === -1 || dragClient.y === -1) ? '' : ('top:' + dragClient.y + 'px;left:' + dragClient.x + 'px;')">
			<!--title-->
			<span :title="$t('messageCenter.messageWindow.closeWin')" class="close-btn" @click="closeWindow">×</span>
			<div class="top-title" @mousedown="mouseDown" @mouseup="mouseUp">
				<p class="title-1">{{$t('messageCenter.messageWindow.backService')}}</p>
				<p class="title-2">{{$t('messageCenter.messageWindow.title')}}</p>
			</div>
			<!--消息面板-->
			<div class="msg-content" id="msg-content">
				<div @click="ladMoreBtn">{{canLoadHis === 1 ? $t('messageCenter.messageWindow.clickLoadMore') : (canLoadHis === 2 ? $t('messageCenter.messageWindow.loading') : $t('messageCenter.messageWindow.noMore'))}}</div>
				<template v-for="(item , i) in dataList">
					<MItem :topText="dataList[len - i].putId === 'Y' ? (dataList[len - i].createTime + ' ' + dataList[len - i].putName) : (dataList[len - i].putName  + ' ' + dataList[len - i].createTime)"
					 :mine="dataList[len - i].putId === 'Y'" :mainText="dataList[len - i].content"></MItem>
				</template>
			</div>
			<!--输入框-->
			<div class="input-util">
				<textarea class="input-box" maxlength="500" v-model="sendContent" :placeholder="$t('messageCenter.messageWindow.placeholder')"></textarea>
				<div class="send-btn" @click="sendBtn">{{$t('messageCenter.messageWindow.send')}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MItem from './MItem';

	export default {
		name: "MessageWindow",
		components: {
			MItem
		},
		props: {
			getId: { //接受消息者ID
				type: String,
				default: ''
			},
			objectId: { //当前消息的业务ID
				type: String,
				default: ''
			},
			objType: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				sendContent: '',
				dataList: [],
				len: 0,
				token: '',
				remark: 0, //最新数据版本
				pageSize: 15,
				pageNum: 1,
				messageBoxDom: null,
				canLoadHis: 1, //1可加载，2加载中 ，3没有更多了
				timers: null,
				timerOut: null,
				timerCount: 0,

				scroll: 0,
				//drag
				drag: {
					drag: false,
					x: -1,
					y: -1
				},
				dragClient: {
					x: -1,
					y: -1
				}
			};
		},
		created() {
			this.token = sessionStorage.getItem('token');
		},
		mounted() {
			this.loadMore('his', 1);
		},
		destroyed() {
			this.timers && clearInterval(this.timers);
			this.timerOut && clearTimeout(this.timerOut);
		},
		methods: {
			ladMoreBtn() {
				if (this.canLoadHis > 1) return;
				this.loadMore('his', this.pageNum);
			},
			/**
			 * 加载更多消息
			 * @param queryType 加载类型 his历史，newst新消息
			 * @param pageNum
			 */
			loadMore(queryType = 'his', pageNum = 1) {
				if (this.canLoadHis > 1) return;
				this.canLoadHis = 2; //loading...
				//记录当前scroll
				this.scroll = this.getScroll();
				this.$get('api/order/message/item/list', {
					getId: this.getId,
					objectId: this.objectId,
					token: this.token,
					remark1: this.remark,
					queryType,
					pageSize: this.pageSize,
					pageNum,
				}).then(res => {
					if (res.code === 0) {
						let data = res.data;
						this.dataList = this.dataList.concat(data);
						this.len = this.dataList.length - 1;
						this.pageNum += 1;
						this.canLoadHis = data.length >= this.pageSize ? 1 : 3;

						if (pageNum === 1 && res.data.length > 0) {
							this.remark = data[0].remark1;
							//十秒钟之后开始轮询
							this.timerOut = setTimeout(() => this.startReFlushMessage(), 10000);
						}
						//100毫秒之后jump到底部
						setTimeout(() => this.jumpToBottom(this.getScroll() - this.scroll), 100);
						return;
					}
					this.$message({
						type: 'error',
						message: this.$t('messageCenter.messageWindow.loadError')
					});
				});
			},
			//开始轮询消息的方法
			startReFlushMessage() {
				this.timers = setInterval(() => {
					if (this.timerCount > 60) {
						clearInterval(this.timers);
						this.closeWindow();
						return;
					}
					this.timerCount += 1;
					this.flushMessage();
				}, 10000);
			},
			//刷新消息
			flushMessage() {
				this.$get('api/order/message/item/list', {
					getId: this.getId,
					objectId: this.objectId,
					token: this.token,
					remark1: this.remark,
					queryType: 'newst',
					pageSize: 10000,
					pageNum: 1
				}).then(res => {
					if (res.code === 0 && res.data.length > 0) {
						let data = res.data;
						this.remark = data[0].remark1;
						this.dataList = data.concat(this.dataList);
						this.len = this.dataList.length - 1;
						setTimeout(() => this.jumpToBottom(), 100);
					}
				});
			},
			//发送消息
			sendBtn() {
				if (!this.sendContent.trim()) return;
				let sendContent = this.sendContent;
				this.sendContent = '';
				this.$post('api/order/message/web/send', {
					content: sendContent,
					getId: this.getId,
					objectId: this.objectId,
					token: this.token,
					objectType: this.objType
				}).then(res => {
					if (res.code !== 0) {
						this.sendContent = sendContent;
						this.$message({
							type: 'error',
							message: this.$t('messageCenter.messageWindow.sendError')
						});
					}
					this.flushMessage();
				});
			},
			//跳转到底部
			jumpToBottom(height = null) {
				if (!this.messageBoxDom) this.messageBoxDom = document.getElementById('msg-content');
				this.messageBoxDom.scrollTop = height === null ? this.messageBoxDom.scrollHeight : height;
			},
			//获取滚动条高度
			getScroll() {
				if (!this.messageBoxDom) this.messageBoxDom = document.getElementById('msg-content');
				return this.messageBoxDom.scrollHeight;
			},
			//关闭窗口
			closeWindow(e) {
				this.timers && clearInterval(this.timers);
				this.timerOut && clearTimeout(this.timerOut);
				this.$emit('closeWindow', {});
				e.cancelBubble = true;
			},
			//mouseUP & down
			changeDrag(flag, e) {
				let drag = this.drag;
				drag.drag = flag;
				if (flag) {
					drag.x = e.offsetX;
					drag.y = e.offsetY;
				}
				this.drag = drag;
			},
			mouseDown(e) {
				this.changeDrag(true, e);
			},
			mouseUp(e) {
				this.changeDrag(false, e);
			},
			mouseMove(e) {
				//若果没有按住鼠标就不触发 drag
				if (!this.drag.drag) return;
				let y = e.clientY - this.drag.y;
				y = y <= 0 ? 0 : y;
				let x = e.clientX - this.drag.x;
				x = x <= 0 ? 0 : x;
				this.dragClient = {
					x,
					y
				};
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/message/MessageWindow.vue